// extracted by mini-css-extract-plugin
export var brand = "_9m-9";
export var compact = "_9m-6";
export var extraSmall = "_9m-7";
export var icon = "_9m-0";
export var large = "_9m-4";
export var light = "_9m-1";
export var medium = "_9m-5";
export var outline = "_9m-b";
export var primaryDark = "_9m-a";
export var primaryLight = "_9m-8";
export var primaryModern = "_9m-c";
export var success = "_9m-2";
export var successSolid = "_9m-3";